<div class="nim__content-area relative">
  <h1 class="h3 bold gray-40">Help Center</h1>
  <div class="card card__block border-navy-87 bg-gray-97 box-shadow mt3">
    <div class="h4 bold center mb2">Call Us</div>
    <div class="h4 mb2 center">To speak to a customer support representative, email us at <strong>support&#64;nucleusinventory.com</strong> or call the
      phone number below.</div>
    <div class="h4 bold mb2 center">1.877.224.9692</div>
    <div class="h4 mb2 center">8 a.m. - 8 p.m. Monday - Friday</div>
    <div class="h4 mb2 center">CT (Central Time)</div>
  </div>
  <div class="container">
    <div class="row no-edge-gutters">
      <div class="col-4">
        <div class="card card__block border-navy-87 bg-gray-97 box-shadow mt3 py5 cursor-pointer">
          <div class="flex justify-content-center mb2">
            <svg class="h2 fill-brand-core">
              <use xlink:href="./assets/icons/connect-icons.svg#Video-Solid"></use>
            </svg>
          </div>
          <div class="h4 center">Training Guides</div>
          <div class="h4 mt1 bold center brand-core">(Coming Soon)</div>
        </div>
      </div>
      <div class="col-4">
        <div class="card card__block border-navy-87 bg-gray-97 box-shadow mt3 py5 cursor-pointer">
          <div class="flex justify-content-center mb2">
            <svg class="h2 fill-brand-core">
              <use xlink:href="./assets/icons/connect-icons.svg#Notes-Solid"></use>
            </svg>
          </div>
          <div class="h4 center">Release Notes</div>
          <div class="h4 mt1 bold center brand-core">(Coming Soon)</div>
        </div>
      </div>
      <div class="col-4">
        <div id="divFeedbackCard" class="card card__block border-navy-87 bg-gray-97 box-shadow mt3 py5 cursor-pointer">
          <div class="flex justify-content-center mb2">
            <svg class="h2 fill-brand-core">
              <use xlink:href="./assets/icons/connect-icons.svg#Feedback-Solid"></use>
            </svg>
          </div>
          <div class="h4 center">Give Feedback</div>
          <div class="h4 mt1 bold center brand-core">(Coming Soon)</div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="flex width100 justify-content-center center absolute bottom-2">
  <a routerLink="../terms-and-conditions"  class="text-link cursor-pointer mln6">Terms &amp; Conditions</a>
</div>
<div class="nim__sidebar">
  <div class="nim__sidebar__top"></div>
  <div class="nim__sidebar__bottom">
  </div>
  <div class="nim__sidebar__global">
    <div nc-global-navigation [isBackEnabled]="true" [isHomeEnabled]="true"></div>
  </div>
</div>
